import api from '@/core/apiclient'
import {actionTypes, mimeTypes, mutationTypes, produto} from '@/core/constants'
import {DownloadUtils} from '@/core/utils'
import ArquivoDownloadUtils from '@/core/utils/ArquivoDownloadUtils'

const downloadUtils = new DownloadUtils()

export default {

    async [actionTypes.ADICIONAR_ANEXO_DADOS_GERAIS]({ commit }, { compraDiretaId, anexo }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.compradorComprasDiretas.adicionarAnexoDadosGerais(compraDiretaId, anexo)
        commit(mutationTypes.SET_ADICIONAR_ANEXO_DADOS_GERAIS, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ADICIONAR_DOCUMENTO_SOLICITADO]({ commit }, { compraDiretaId, documentoId }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.documentosSolicitados.adicionar(compraDiretaId, documentoId)
        commit(mutationTypes.SET_ADICIONAR_DOCUMENTO_SOLICITADO, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ADICIONAR_EMAIL_CONVIDADO]({ commit }, { compraDiretaId, email }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.convidados.adicionar(compraDiretaId, email)
        commit(mutationTypes.SET_ADICIONAR_EMAIL_CONVIDADO, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ADICIONAR_LINHA_DE_FORNECIMENTO]({ commit }, { compraDiretaId, linha }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.linhasFornecimento.adicionar(compraDiretaId, linha)
        commit(mutationTypes.SET_ADICIONAR_LINHA_DE_FORNECIMENTO, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ALTERAR_EXCLUSIVIDADE_ITEM]({ commit }, { compraDiretaId, id, novoValor }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        await api.compradorComprasDiretas.alterarExclusividadeItem(compraDiretaId, id, novoValor)
        commit(mutationTypes.SET_ALTERAR_EXCLUSIVIDADE_ITEM, { id, novoValor })
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ALTERAR_EXCLUSIVIDADE_LOTE]({ commit }, { compraDiretaId, id, novoValor }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        await api.compradorComprasDiretas.alterarExclusividadeLote(compraDiretaId, id, novoValor)
        commit(mutationTypes.SET_ALTERAR_EXCLUSIVIDADE_LOTE, { id, novoValor })
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.ALTERAR_SITUACAO_DE_ITEM_E_LOTE]({ dispatch }, { compraDiretaId, dados }) {
        await api.compradorComprasDiretas.alterarSituacaoDeItemELote(compraDiretaId, dados)
        await dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
    },

    async [actionTypes.SUSPENDER_COMPRA_DIRETA]({ dispatch, commit }, { compraDiretaId, dados }) {
        await api.compradorComprasDiretas.suspenderCompraDireta(compraDiretaId, dados)
        commit(mutationTypes.SET_COMPRA_DIRETA_SUSPENSA, true)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.RETOMAR_COMPRA_DIRETA]({ dispatch, commit }, { compraDiretaId, dados }) {
        await api.compradorComprasDiretas.retomarCompraDireta(compraDiretaId, dados)
        commit(mutationTypes.SET_COMPRA_DIRETA_SUSPENSA, false)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
    },

    async [actionTypes.ATUALIZAR_TIPO_ANEXO_DADOS_GERAIS]({ commit }, { compraDiretaId, anexo }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.compradorComprasDiretas.atualizarTipoAnexoDadosGerais(compraDiretaId, anexo)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
        return data
    },

    async [actionTypes.ATUALIZAR_SESSAO_DOMINIO]({ commit, dispatch }, { dominioClienteId, dominioTipo }) {
        await api.usuario.atualizarSessaoDominio(dominioClienteId, dominioTipo)
        await dispatch(actionTypes.BUSCAR_USUARIO_LOGADO)
        commit(mutationTypes.SET_MENU_AVATAR)
    },

    async [actionTypes.BUSCAR_LINGUAGEM]({ commit }) {
        const { data } = await api.compraDireta.buscarLinguagem()
        commit(mutationTypes.SET_LINGUAGEM, data.linguagem)
    },

    async [actionTypes.ATUALIZAR_SESSAO_DOMINIO_UNICO]({ dispatch, state }) {
        const dominioDTO = {
            dominioClienteId: state.perfis[0].chaveCliente,
            dominioTipo: state.perfis[0].tipoCliente
        }
        await dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, dominioDTO)
    },

    async [actionTypes.BUSCAR_DADOS_GERAIS]({ commit }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarDadosGerais(compraDiretaId)
        commit(mutationTypes.SET_DADOS_GERAIS, data)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS]({ commit }, compraDiretaId) {
        const { data } = await api.documentos.buscarPorNivelCompraDireta(compraDiretaId)
        commit(mutationTypes.SET_DOCUMENTOS, data.documentos)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA]({ commit }) {
        const { data } = await api.documentos.buscarPorNivelProposta()
        commit(mutationTypes.SET_DOCUMENTOS_PROPOSTA, data.documentos)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_SOLICITADOS]({ commit }, compraDiretaId) {
        const { data } = await api.documentosSolicitados.buscar(compraDiretaId)
        commit(mutationTypes.SET_DOCUMENTOS_SOLICITADOS, data.items)
    },

    async [actionTypes.COMPRADOR.BUSCAR_DOCUMENTOS_VIRTUALIZADOS](context, compradiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarDocumentosVirtualizados(compradiretaId)
        return data
    },

    async [actionTypes.BUSCAR_DOMINIO_PERFIL_USUARIO]({ commit, dispatch, state }, { usuarioId, perfilTipo }) {
        const { data } = await api.usuario.buscarDominioPerfil(usuarioId, perfilTipo)
        commit(mutationTypes.SET_PERFIS, data)
        if (state.perfis.length === 1) {
            await dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO_UNICO)
        }
    },

    async [actionTypes.BUSCAR_CONVIDADOS_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.convidados.buscar(compraDiretaId)
        commit(mutationTypes.SET_CONVIDADOS_DA_COMPRA_DIRETA, data.items)
    },

    async [actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO]({ commit }, conteudo) {
        const { data } = await api.linhasFornecimento.buscar(conteudo)
        commit(mutationTypes.SET_LINHAS_DE_FORNECIMENTO, data.items)
    },

    async [actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.linhasFornecimento.buscarDaCompraDireta(compraDiretaId)
        commit(mutationTypes.SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA, data.items)
    },

    async [actionTypes.BUSCAR_LINK_EDITAR_USUARIO]({ state }) {
        const payload = {
            uri: window.location.origin + window.location.pathname,
            produto: state.loki.product.name
        }
        const { data } = await api.usuario.editar(payload)
        return data
    },

    async [actionTypes.BUSCAR_ITENS_E_LOTES]({ commit }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarItensELotes(compraDiretaId)
        commit(mutationTypes.SET_ITENS_E_LOTES, data)
    },

    async [actionTypes.BUSCAR_PARAMETROS]({ commit }) {
        const { data } = await api.compraDireta.buscarParametros()
        commit(mutationTypes.SET_PARAMETROS, data)
    },

    async [actionTypes.BUSCAR_PRODUTO_POR_NOME]({ commit }) {
        const { data } = await api.produto.buscarPorNome(produto.NOME)
        commit(mutationTypes.SET_PRODUTO, data)
    },

    async [actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarResumoCompraDireta(compraDiretaId)
        commit(mutationTypes.SET_RESUMO_DA_COMPRA_DIRETA, data)
    },

    async [actionTypes.BUSCAR_RESUMO_ITEM_E_LOTE]({ dispatch }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarResumoItemELote(compraDiretaId)
        return dispatch(actionTypes.FORMATAR_LISTA_DE_ITENS_E_LOTES, data)
    },

    async [actionTypes.BUSCAR_USUARIO_LOGADO]({ commit, state }) {
        const produtoId = state.loki.product.id
        const { data } = await api.usuario.buscarLogado(produtoId)
        commit(mutationTypes.SET_USUARIO_LOGADO, data)
    },

    async [actionTypes.COMPRADOR.ADICIONAR_DOCUMENTO_SEM_VINCULO]({ dispatch }, { compraDiretaId, documento }) {
        const { data } = await api.documentosSolicitados.adicionarDocumentoSemVinculo(documento)
        const dadosObj = {
            compraDiretaId: compraDiretaId,
            documentoId: data.id
        }
        await dispatch(actionTypes.ADICIONAR_DOCUMENTO_SOLICITADO, dadosObj)
    },

    async [actionTypes.COMPRADOR.IMPORTAR_ARQUIVO_DE_ITENS_E_LOTES]({ dispatch }, { compraDiretaId, arquivo }) {
        if (arquivo.tipo === 'COMPRAS') {
            await api.compradorComprasDiretas.importarCompras(compraDiretaId, arquivo)
        } else {
            await api.compradorComprasDiretas.importarPlanilha(compraDiretaId, arquivo)
        }
        await dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.ADJUDICAR_FORNECEDOR]({ dispatch }, { compraDiretaId, itens}) {
        const response = await api.compradorComprasDiretas.adjudicarFornecedor(compraDiretaId, itens)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        return response
    },

    async [actionTypes.COMPRADOR.VERIFICAR_SALDO_SUBELEMENTO](context, { compraDiretaId, tipoItemOuLote, rankingId }) {
        const { data } = await api.compradorComprasDiretas.verificarSaldoSubelemento(compraDiretaId, rankingId, tipoItemOuLote)
        return data
    },

    async [actionTypes.COMPRADOR.DECLARAR_FORNECEDOR_VENCEDOR]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote }) {
        await api.compradorComprasDiretas.declararFornecedorVencedor(compraDiretaId, rankingId, tipoItemOuLote)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.ENVIAR_PARA_HOMOLOGACAO]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote }) {
        await api.compradorComprasDiretas.enviarParaHomologacao(compraDiretaId, rankingId, tipoItemOuLote)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.CANCELAR_ENVIO_PARA_HOMOLOGACAO]({ dispatch }, { compraDiretaId, rankingId, tipo }) {
        await api.compradorComprasDiretas.cancelarEnvioParaHomologacao(compraDiretaId, rankingId, tipo)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO]({ commit }, { compraDiretaId, fornecedorId, documentoSolicitadoId,
        documentoApresentadoId, situacao, motivoReenvio }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.compradorComprasDiretas.atualizarAnaliseDeDocumentoSelecionado(compraDiretaId, fornecedorId, documentoSolicitadoId, documentoApresentadoId,
            situacao, motivoReenvio)
        const novaSituacao = data.novaSituacao
        // TODO Ajustar mutation para atualizar documento pelo documentoApresentadoId
        commit(mutationTypes.COMPRADOR.SET_ATUALIZAR_ANALISE_DE_DOCUMENTO, { documentoSolicitadoId, novaSituacao })
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.COMPRADOR.SOLICITAR_ENVIO_DO_DOCUMENTO_SELECIONADO](context, { compraDiretaId, fornecedorId, documentoSolicitadoId, mensagem }) {
        await api.compradorComprasDiretas.solicitarEnvioDeDocumentoSelecionado(compraDiretaId, fornecedorId, documentoSolicitadoId, mensagem)
    },

    async [actionTypes.COMPRADOR.SOLICITAR_ASSINATURA_DO_DOCUMENTO_SELECIONADO]({ commit }, { compraDiretaId, fornecedorId, documentoId, tipoDocumento,
        descricaoDocumento, documentoVirtualizadoId, renovarAssinatura, conviteId }) {
        const { data } = await api.compradorComprasDiretas.solicitarAssinaturaDoDocumentoSelecionado(compraDiretaId, fornecedorId, documentoId, tipoDocumento,
            descricaoDocumento, documentoVirtualizadoId, renovarAssinatura, conviteId)

        if (tipoDocumento === 'DOCUMENTO_APRESENTADO') {
            commit(mutationTypes.COMPRADOR.SET_ASSINATURA_SOLICITADA_DOCUMENTO_APRESENTADO, data)
        } else {
            commit(mutationTypes.COMPRADOR.SET_ASSINATURA_SOLICITADA_REAJUSTE_PROPOSTA, data)
        }
    },

    async [actionTypes.COMPRADOR.BAIXAR_DOCUMENTO_DO_FORNECEDOR](context, documento) {
        const response = await api.compradorComprasDiretas.baixarDocumentoFornecedor(documento.url)
        const { nome, contentType } = ArquivoDownloadUtils.resolveDownloadInfo(response, documento.nome, mimeTypes.pdf)
        downloadUtils.baixarBlob(response.data, nome, contentType)
    },

    //TESTADO - OK
    async [actionTypes.COMPRADOR.BAIXAR_HISTORICO_DE_LANCES](context, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.baixarHistoricoDeLances(compraDiretaId)
        const nomeArquivo = 'Relatorio_de_Historico_de_Lances.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.BAIXAR_RESULTADO_ITENS_E_LOTES](context, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.baixarResultadoItensLotes(compraDiretaId)
        const nomeArquivo = 'Relatorio_de_Resultado_de_Itens_e_Lotes.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.BUSCAR_ANALISE_DOCUMENTOS_DO_FORNECEDOR]({ commit }, { compraDiretaId, fornecedorId, itemLoteId, itemLoteTipo }) {
        const { data } = await api.compradorComprasDiretas.buscarDocumentosAnalise(compraDiretaId, fornecedorId, itemLoteId, itemLoteTipo)
        commit(mutationTypes.COMPRADOR.SET_ANALISE_DOCUMENTOS_DO_FORNECEDOR, data)
    },

    async [actionTypes.COMPRADOR.BUSCAR_COMPRAS_DIRETAS_EM_ANDAMENTO]({ state }) {
        const { filtros, paginacao } = state.comprador.resultadoBuscaComprasDiretasEmAndamento
        const { data } = await api.compradorComprasDiretas.buscarComprasDiretasEmAndamento(filtros, paginacao)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_COMPRAS_DIRETAS_EM_ELABORACAO]({ state }) {
        const { filtros, paginacao } = state.comprador.resultadoBuscaComprasDiretasEmElaboracao
        const { data } = await api.compradorComprasDiretas.buscarComprasDiretasEmElaboracao(filtros, paginacao)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_COMPRAS_DIRETAS_ENCERRADAS]({ state }) {
        const { filtros, paginacao } = state.comprador.resultadoBuscaComprasDiretasEncerradas
        const { data } = await api.compradorComprasDiretas.buscarComprasDiretasEncerradas(filtros, paginacao)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_DADOS_ACOMPANHAMENTO]({ commit }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarDadosDeAcompanhamento(compraDiretaId)
        commit(mutationTypes.COMPRADOR.SET_DADOS_ACOMPANHAMENTO, data)
    },

    async [actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES]({ commit, state }, payload) {
        let compraDiretaId = payload
        let page
        let rowsPerPage

        if (typeof payload === 'object' && payload !== null) {
            compraDiretaId = payload.compraDiretaId
            page = payload.page
            rowsPerPage = payload.rowsPerPage
        }

        const defaultPage = 0
        const defaultRowsPerPage = 10

        const pagina = page === null ? 0 : (page === undefined ? defaultPage : page)
        const tamanhoPagina = rowsPerPage === null ? 10 : (rowsPerPage === undefined ? defaultRowsPerPage : rowsPerPage)

        const { data } = await api.compradorComprasDiretas.buscarResultadoItensELotes(compraDiretaId, pagina, tamanhoPagina)
        commit(mutationTypes.COMPRADOR.SET_RESULTADO_ITENS_E_LOTES, data.itensOuLotesResultado)
        commit(mutationTypes.COMPRADOR.SET_RESULTADO_ATUALIZAR_DADOS_DA_COMPRA_DIRETA, data)

        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_TODAS_COMPRAS_DIRETAS]({ state }) {
        const { filtros, paginacao } = state.comprador.resultadoBuscaTodasComprasDiretas
        const { data } = await api.compradorComprasDiretas.buscarTodasComprasDiretas(filtros, paginacao)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR]({ state }) {
        const { filtros, paginacao } = state.comprador.resultadoBuscaAvancadaComprasDiretas

        const { data } = await api.compraDireta.buscarAvancadaComprasDiretas(filtros, paginacao)
        return data
    },

    async [actionTypes.FORNECEDOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR]({ state }) {
        const { filtros, paginacao } = state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor

        const { data } = await api.compraDireta.buscarAvancadaComprasDiretas(filtros, paginacao)
        return data
    },

    async [actionTypes.COMPRADOR.DESCLASSIFICAR_FORNECEDOR]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote, motivo }) {
        await api.compradorComprasDiretas.desclassificarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.INABILITAR_FORNECEDOR]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote, motivo, fornecedorId, inabilitarTodos }){
        await api.compradorComprasDiretas.inabilitarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo, fornecedorId, inabilitarTodos)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.HABILITAR_FORNECEDOR]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote, motivo, fornecedorId, habilitarTodos }){
        await api.compradorComprasDiretas.habilitarFornecedor(compraDiretaId, tipoItemOuLote, rankingId, motivo, fornecedorId, habilitarTodos)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.RECLASSIFICAR_FORNECEDOR]({ dispatch }, { compraDiretaId, rankingId, tipoItemOuLote, motivo }) {
        await api.compradorComprasDiretas.reclassificarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.CANCELAR_ADJUDICACAO]({ dispatch, commit }, { compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo, itemOuLoteId }) {
        await api.compradorComprasDiretas.cancelarAdjudicacao(compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
        commit(mutationTypes.COMPRADOR.SET_SITUACAO_RANKING_EM_ANALISE, { itemOuLoteId: itemOuLoteId, rankingId: rankingId })
    },

    async [actionTypes.COMPRADOR.CANCELAR_DECLARACAO_VENCEDOR]({ dispatch, commit }, { compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo, itemOuLoteId }) {
        await api.compradorComprasDiretas.cancelarDeclaracaoVencedor(compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
        commit(mutationTypes.COMPRADOR.SET_SITUACAO_RANKING_EM_ANALISE, { itemOuLoteId: itemOuLoteId, rankingId: rankingId })
    },

    async [actionTypes.COMPRADOR.DESEMPATAR_FORNECEDORES](context, { compraDiretaId, itemOuLoteId, ...requestData }) {
        const { data } =await api.compradorComprasDiretas.desempatarFornecedores(compraDiretaId, itemOuLoteId, requestData)
        return data
    },

    async [actionTypes.COMPRADOR.DESEMPATAR_FORNECEDORES_ETAPA_FECHADA](context, { compraDiretaId, itemOuLoteId, tipo }) {
        await api.compradorComprasDiretas.desempatarFornecedoresEtapaFechada(compraDiretaId, itemOuLoteId, tipo)
    },

    async [actionTypes.COMPRADOR.DESEMPATAR_FORNECEDOR_MANUALMENTE](context, { compraDiretaId, itemOuLoteId, ...requestData }) {
        const { data } = await api.compradorComprasDiretas.desempatarFornecedoresManualmente(compraDiretaId, itemOuLoteId, requestData)
        return data
    },

    async [actionTypes.COMPRADOR.NEGOCIAR_ITEM_OU_LOTE]({ commit }, { compraDiretaId, itemOuLoteId, rankingId, tipoItemOuLote, mensagem }) {
        const { data } = await api.compradorComprasDiretas.negociarItemOuLote(compraDiretaId, rankingId, tipoItemOuLote, mensagem)
        commit(mutationTypes.COMPRADOR.SET_SITUACAO_NEGOCIACAO, {
            id: data.id,
            mensagemComprador: data.mensagemComprador,
            valorPosterior: data.valorPosterior,
            itemOuLoteId: itemOuLoteId,
            rankingId: rankingId
        })
    },

    async [actionTypes.COMPRADOR.BUSCAR_INFORMACOES_SISTEMA]({ commit }) {
        commit(mutationTypes.LOKI.DISABLE_GLOBAL_LOADING)
        const { data } = await api.compradorComprasDiretas.buscarInformacoesSistema()
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        return data
    },

    async [actionTypes.EXPORTAR_COMPRA_DIRETA](context, compraDiretaId) {
        await api.compradorComprasDiretas.exportar(compraDiretaId)
        await context.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.EXPORTAR_RESULTADOS_COMPRAS_PREPARACAO](context, compraDiretaId) {
        await api.compradorComprasDiretas.exportarComprasPreparacao(compraDiretaId)
        await context.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
    },

    async [actionTypes.EXPORTAR_COMPRA_DIRETA_MAIS_BRASIL]({ commit, dispatch }, { compraDiretaId, situacao }) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const { data } = await api.compradorComprasDiretas.exportarMaisBrasil(compraDiretaId, situacao)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        return data
    },

    async [actionTypes.BAIXAR_RELATORIO_MAIS_BRASIL]({ commit }, { compraDiretaId }) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const { data } = await api.compradorComprasDiretas.relatorioMaisBrasil(compraDiretaId)
        const nomeArquivo = 'MaisBrasil.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.EXPORTAR_COMPRA_DIRETA_ARQUIVO](context, { compraDiretaId, tipoExportacao }) {
        const { data, headers } = await api.compradorComprasDiretas.exportarArquivo(compraDiretaId, tipoExportacao)
        let blob = new Blob([data], {
            type: mimeTypes.txt
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)

        downloadLink.download = 'exportação-itens.txt'

        if (headers && headers.filename)
            downloadLink.download = headers.filename

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    [actionTypes.FORNECEDOR.ATUALIZAR_VALOR_INSERIDO_PARA_LANCE]({ commit }, item) {
        commit(mutationTypes.FORNECEDOR.SET_NOVO_VALOR_INSERIDO_PARA_LANCE, item)
    },

    async [actionTypes.FORNECEDOR.ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA]({ commit }, { compraDiretaId, arquivo }) {
        const { data } = await api.fornecedorComprasDiretas.adicionarAnexoDocumentoSolicitado(compraDiretaId, arquivo)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_DOCUMENTO_SOLICITADO_DA_PROPOSTA, data)
    },

    async [actionTypes.COMPRADOR.ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA]({ commit }, { compraDiretaId, arquivo, fornecedorId }) {
        const { data } = await api.compradorComprasDiretas.adicionarAnexoDocumentoSolicitado(compraDiretaId, arquivo, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_DOCUMENTO_SOLICITADO_DA_PROPOSTA, data)
    },

    async [actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA](context, compraDiretaId) {
        const { data } = await api.compraDireta.baixarRelatorioDaAta(compraDiretaId)
        const nomeArquivo = 'Relatorio_da_Ata.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLOS](context, { idVirtualizado, opcaoDownloadVirtualizacao, noProcessoDigital }) {
        const nomeArquivo = 'Relatorio_de_Protocolo.pdf'
        const { data } = await api.fornecedorComprasDiretas.baixarRelatorioDeProtocolos(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, noProcessoDigital)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_REAJUSTES](context, { idVirtualizado, opcaoDownloadVirtualizacao }) {
        const nomeArquivo = 'Relatorio_de_Reajustes.pdf'
        const { data } = await api.fornecedorComprasDiretas.baixarRelatorioDeReajustes(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    //Isso deveria estar sendo usado?
    async [actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_REAJUSTES_NAO_VIRTUALIZADO](context, { compraDiretaId }) {
        const nomeArquivo = 'Relatorio_de_Reajustes.pdf'
        const { data } = await api.fornecedorComprasDiretas.baixarRelatorioDeReajustesNaoVirtualizado(compraDiretaId)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLO_PREVIEW](context, { compraDiretaId, propostaId }) {
        const { data } = await api.fornecedorComprasDiretas.baixarRelatorioDeProtocolosPreview(compraDiretaId, propostaId)
        const nomeArquivo = 'Relatorio_de_Protocolos.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA]({ commit }, { compraDiretaId, propostaId }) {
        const { data } = await api.fornecedorComprasDiretas.buscarResumoProposta(compraDiretaId, propostaId)
        commit(mutationTypes.FORNECEDOR.SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, data)
    },
    
    async [actionTypes.COMPRADOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA]({ commit }, { compraDiretaId, propostaId, fornecedorId }) {
        const { data } = await api.compradorComprasDiretas.buscarResumoProposta(compraDiretaId, propostaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, data)
    },
    
    async [actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_ENCERRADAS]({ state }) {
        const { filtros, paginacao } = state.fornecedor.resultadoBuscaComprasDiretasEncerradas
        const { data } = await api.fornecedorComprasDiretas.buscarComprasDiretasEncerradas(filtros, paginacao)
        return data
    },

    async [actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_DISPONIVEIS]({ state }) {
        const { filtros, paginacao } = state.fornecedor.resultadoBuscaComprasDiretasDisponiveis
        const { data } = await api.fornecedorComprasDiretas.buscarComprasDiretasDisponiveis(filtros, paginacao)
        return data
    },

    async [actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarDetalhes(compraDiretaId)
        commit(mutationTypes.SET_COMPRA_DIRETA, data)
    },

    async [actionTypes.COMPRADOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarDetalhesComprador(compraDiretaId)
        commit(mutationTypes.SET_COMPRA_DIRETA, data)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarDocumentosSolicitados(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, data.documentos)
    },

    async [actionTypes.COMPRADOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA]({ commit }, { compraDiretaId, fornecedorId}) {
        const { data } = await api.compradorComprasDiretas.buscarDocumentosSolicitados(compraDiretaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, data.documentos)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_DA_PROPOSTA]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarItensELotesDaProposta(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_ITENS_E_LOTES_DA_PROPOSTA, data)
    },

    async [actionTypes.COMPRADOR.BUSCAR_ITENS_E_LOTES_DA_PROPOSTA]({ commit }, { compraDiretaId, fornecedorId}) {
        const { data } = await api.compradorComprasDiretas.buscarItensELotesDaProposta(compraDiretaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_ITENS_E_LOTES_DA_PROPOSTA, data)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarItensELotesVencedoresAReajustar(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR, data)
        commit(mutationTypes.FORNECEDOR.SET_QUANTIDADE_DE_CASAS_DECIMAIS_DA_COMPRA_DIRETA, data.casaDecimal)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_LANCES_DA_COMPRA_DIRETA]({ commit }, { compraDiretaId, propostaId }) {
        const { data } = await api.fornecedorComprasDiretas.buscarLancesDaCompraDireta(compraDiretaId, propostaId)
        commit(mutationTypes.FORNECEDOR.SET_LANCES_DA_COMPRA_DIRETA, data.lances)
        commit(mutationTypes.FORNECEDOR.SET_QUANTIDADE_DE_CASAS_DECIMAIS_DA_COMPRA_DIRETA, data.casaDecimal)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_MEUS_LOTES_E_ITENS_VENCEDORES]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarMeusLotesItensVencedores(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_MEUS_LOTES_E_ITENS_VENCEDORES, data.itens)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_MINHAS_COMPRAS_DIRETAS]({ state }) {
        const { filtros, paginacao } = state.fornecedor.resultadoBuscaMinhasComprasDiretas
        const { data } = await api.fornecedorComprasDiretas.buscarMinhasComprasDiretas(filtros, paginacao)
        return data
    },

    async [actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_MEU_INTERESSE]({ state }) {
        const { filtros, paginacao } = state.fornecedor.resultadoBuscaMeuInteresseComprasDiretas
        const { data } = await api.fornecedorComprasDiretas.buscarComprasDiretasMeuinteresse(filtros, paginacao)
        return data
    },

    async [actionTypes.FORNECEDOR.BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarResultadoLotesItens(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_RESULTADO_DE_TODOS_LOTES_E_ITENS, data.itens)
        commit(mutationTypes.FORNECEDOR.SET_QUANTIDADE_DE_CASAS_DECIMAIS_DA_COMPRA_DIRETA, data.casaDecimal)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_TERMOS]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.buscarTermos(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
    },

    async [actionTypes.COMPRADOR.BUSCAR_TERMOS]({ commit }, { compraDiretaId, fornecedorId }) {
        const { data } = await api.compradorComprasDiretas.buscarTermos(compraDiretaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
    },

    async [actionTypes.FORNECEDOR.CRIAR_TERMOS]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.criarTermos(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
    },

    async [actionTypes.COMPRADOR.CRIAR_TERMOS]({ commit }, { compraDiretaId, fornecedorId }) {
        const { data } = await api.compradorComprasDiretas.criarTermos(compraDiretaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
    },

    async [actionTypes.FORNECEDOR.CANCELAR_ENVIO_DA_PROPOSTA_SEM_DISPUTA](context, { compraDiretaId, propostaId, numeroProtocolo }) {
        const { data } = await api.fornecedorComprasDiretas.cancelarEnvioDaPropostaSemDisputa(compraDiretaId, propostaId, numeroProtocolo)
        await context.dispatch(actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, compraDiretaId)
        return data
    },

    async [actionTypes.FORNECEDOR.CANCELAR_ENVIO_DA_PROPOSTA_COM_DISPUTA](context, { compraDiretaId, propostaId, numeroProtocolo }) {
        const { data } = await api.fornecedorComprasDiretas.cancelarEnvioDaPropostaComDisputa(compraDiretaId, propostaId, numeroProtocolo)
        await context.dispatch(actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, compraDiretaId)
        return data
    },

    async [actionTypes.FORNECEDOR.CANCELAR_LANCE](context, { compraDiretaId, propostaId, item }) {
        return await api.fornecedorComprasDiretas.cancelarLance(compraDiretaId, propostaId, item)
    },

    async [actionTypes.FORNECEDOR.CANCELAR_LANCE_DESEMPATE](context, { compraDiretaId, ...requestData}) {
        return await api.fornecedorComprasDiretas.cancelarLanceDesempate(compraDiretaId, requestData)
    },

    // eslint-disable-next-line max-len
    async [actionTypes.FORNECEDOR.DECIDIR_NEGOCIACAO_LOTE_OU_ITEM_DO_REAJUSTE]({ commit }, { compraDiretaId, id, itemOuLoteReajusteId, itemOuLoteCompraDiretaId, tipo, aceito, valor }) {
        const { data } = await api.fornecedorComprasDiretas.decidirNegociacaoLoteOuItemDoReajuste(
            compraDiretaId, id, itemOuLoteReajusteId, itemOuLoteCompraDiretaId, tipo, aceito, valor
        )
        commit(mutationTypes.FORNECEDOR.SET_NOVO_ESTADO_DE_ACEITE_NEGOCIACAO_REAJUSTE, data)
    },

    async [actionTypes.FORNECEDOR.SALVAR_TERMOS]({ commit }, { compraDiretaId, propostaId, termos }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.fornecedorComprasDiretas.salvarTermos(compraDiretaId, propostaId, termos)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.COMPRADOR.SALVAR_TERMOS]({ commit }, { compraDiretaId, propostaId, termos }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.compradorComprasDiretas.salvarTermos(compraDiretaId, propostaId, termos)
        commit(mutationTypes.FORNECEDOR.SET_TERMOS, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.FORNECEDOR.EFETUAR_LANCE]({ commit }, { compraDiretaId, propostaId, dados }) {
        const { data } = await api.fornecedorComprasDiretas.efetuarLance(compraDiretaId, propostaId, dados)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_MEU_ULTIMO_LANCE, { data, dados })
    },

    async [actionTypes.FORNECEDOR.EFETUAR_LANCE_DESEMPATE](context, requisicaoData) {
        await api.fornecedorComprasDiretas.efetuarLanceDesempate(requisicaoData)
    },

    async [actionTypes.FORNECEDOR.ENVIAR_PROPOSTA](context, { compraDiretaId, propostaId, validarMargem }) {
        const {data} = await api.fornecedorComprasDiretas.enviarProposta(compraDiretaId, propostaId, validarMargem)
        await context.dispatch(actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.ENVIAR_PROPOSTA](context, { compraDiretaId, propostaId, validarMargem, fornecedorId }) {
        const {data} = await api.compradorComprasDiretas.enviarProposta(compraDiretaId, propostaId, validarMargem, fornecedorId)
        await context.dispatch(actionTypes.COMPRADOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, {
            compraDiretaId,
            fornecedorId
        })
        return data
    },

    async [actionTypes.FORNECEDOR.ENVIAR_REAJUSTE_LOTE](context, { compraDiretaId, loteCompraDiretaId }) {
        await api.fornecedorComprasDiretas.enviarReajusteLote(compraDiretaId, loteCompraDiretaId)
    },

    async [actionTypes.COMPRADOR.ENVIAR_REAJUSTE_LOTE](context, { compraDiretaId, loteCompraDiretaId, fornecedorId }) {
        await api.compradorComprasDiretas.enviarReajusteLote(compraDiretaId, loteCompraDiretaId, fornecedorId)
    },

    async [actionTypes.FORNECEDOR.ENVIAR_DOCUMENTOS_ANALISE]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.enviarDocumentosAnalise(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_TODOS_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, data)
    },

    async [actionTypes.FORNECEDOR.REMOVER_PROPOSTA](context, compra) {
        return await api.fornecedorComprasDiretas.removerProposta(compra)
    },

    async [actionTypes.COMPRADOR.REMOVER_PROPOSTA](context, { compraDiretaId, propostaId, fornecedorId}) {
        return await api.compradorComprasDiretas.removerProposta(compraDiretaId, propostaId, fornecedorId)
    },

    async [actionTypes.FORNECEDOR.REMOVER_DOCUMENTO_APRESENTADO](context, { compraDiretaId, documentoApresentadoId }) {
        return await api.fornecedorComprasDiretas.removerDocumentoApresentado(compraDiretaId, documentoApresentadoId)
    },

    async [actionTypes.COMPRADOR.REMOVER_DOCUMENTO_APRESENTADO](context, { compraDiretaId, documentoApresentadoId, fornecedorId}) {
        return await api.compradorComprasDiretas.removerDocumentoApresentado(compraDiretaId, documentoApresentadoId, fornecedorId)
    },

    async [actionTypes.FORNECEDOR.SALVAR_ITEM_DA_PROPOSTA]({ commit }, itemProposta) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        await api.fornecedorComprasDiretas.salvarValorIndividual(itemProposta)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_ITEM_E_LOTE_DA_PROPOSTA, itemProposta)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.COMPRADOR.SALVAR_ITEM_DA_PROPOSTA]({ commit }, itemProposta) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        await api.compradorComprasDiretas.salvarValorIndividual(itemProposta)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_ITEM_E_LOTE_DA_PROPOSTA, itemProposta)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.FORNECEDOR.SALVAR_ITEM_DO_REAJUSTE]({ commit }, { compraDiretaId, item }) {
        commit(mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
        const { data } = await api.fornecedorComprasDiretas.salvarItemDoReajuste(compraDiretaId, item)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_ITEM_E_LOTE_DO_REAJUSTE, data)
        commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    },

    async [actionTypes.FORNECEDOR.VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR]({ commit }, compraDiretaId) {
        const { data } = await api.fornecedorComprasDiretas.verificarSePossuiLoteItemVencedor(compraDiretaId)
        commit(mutationTypes.FORNECEDOR.SET_VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR, data.possuiLoteItemVencedor)
    },

    async [actionTypes.IMPORTAR_PROCESSO](context, processo) {
        const { data } = await api.importacao.buscarNumeroProcesso({...processo })
        return data
    },

    async [actionTypes.REIMPORTAR_PROCESSO](context, processo) {
        const { data } = await api.importacao.reimportarProcesso(processo)
        return data
    },

    async [actionTypes.COMPRADOR.NOVA_COMPRA_DIRETA](context, processo) {
        const { data } = await api.compradorComprasDiretas.criarCompraDireta(processo)
        return data
    },

    async [actionTypes.COMPRADOR.ENCERRAR_COMPRA_DIRETA]({ dispatch }, compraDiretaId) {
        await api.compradorComprasDiretas.encerrarCompraDireta(compraDiretaId)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.DESPUBLICAR_COMPRA_DIRETA](context, { compraDiretaId, motivo }) {
        await api.compradorComprasDiretas.despublicarCompraDireta(compraDiretaId, motivo)
    },

    async [actionTypes.COMPRADOR.PRORROGAR_COMPRA_DIRETA](context, { compraDiretaId, motivo, dataHoraAtualizada }) {
        await api.compradorComprasDiretas.prorrogarCompraDireta(compraDiretaId, motivo, dataHoraAtualizada)
    },

    async [actionTypes.COMPRADOR.BUSCAR_EVENTOS_POS_PUBLICACAO](context, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.buscarEventosPosPublicacao(compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.REVERTER_SITUACAO_ITEM_LOTE]({dispatch}, { compraDiretaId, itemOuLoteId, isLote }) {
        const { data } = await api.compradorComprasDiretas.reverterSituacaoItemLote(compraDiretaId, itemOuLoteId, isLote)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraDiretaId)
        await dispatch(actionTypes.BUSCAR_DADOS_GERAIS, compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_REQUISICOES_POR_SISTEMA]({commit, state}, sistema) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const { paginacao, filtros } = state.comprador.filaRequisicoes
        const { data } = await api.compradorComprasDiretas.buscarRequisicoesPorSistema(sistema, paginacao, filtros)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_REQUEST_BODY_DA_REQUISICAO](context, requisicaoId) {
        const { data } = await api.compradorComprasDiretas.buscarRequestBodyDaRequisicao(requisicaoId)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_REQUISICOES_COM_ERRO_POR_SISTEMA]({commit, state}, sistema) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const { paginacao, filtros } = state.comprador.filaRequisicoesComErro
        const { data } = await api.compradorComprasDiretas.buscarRequisicoesPorSistema(sistema, paginacao, filtros)
        return data
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_REQUISICAO_HTTP]({commit}, requisicao) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const { data } = await api.compradorComprasDiretas.atualizarRequisicaoHttp(requisicao)
        return data
    },

    async [actionTypes.COMPRADOR.REENVIAR_REQUISICAO_HTTP]({commit}, requisicaoId) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        await api.compradorComprasDiretas.reenviarRequisicaoHttp(requisicaoId)
    },

    async [actionTypes.REMOVER_ANEXO_DADOS_GERAIS]({ commit }, { compraDiretaId, anexoId }) {
        await api.compradorComprasDiretas.excluirAnexoDadosGerais(compraDiretaId, anexoId)
        commit(mutationTypes.SET_REMOVER_ANEXO_DADOS_GERAIS, anexoId)
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_SITUACAO_ANEXO_COMPRA_DIRETA]({ commit }, itemObj) {
        await api.compradorComprasDiretas.atualizarSituacaoAnexoCompraDireta(itemObj)
        commit(mutationTypes.SET_SITUACAO_ANEXO, itemObj)
    },

    async [actionTypes.COMPRADOR.BUSCAR_ORGAOS_DISPONIVEIS]({ commit }, compraDiretaId) {
        let resultado = await api.compradorComprasDiretas.buscarOrgaosDisponiveis(compraDiretaId)
        commit(mutationTypes.SET_ORGAOS_DISPONIVEIS, resultado.data.orgaos)
    },

    async [actionTypes.REMOVER_COMPRA_DIRETA](context, payload) {
        let compraDiretaId = payload
        let removerNaOrigem
        if (typeof payload === 'object' && payload !== null) {
            compraDiretaId = payload.compraDiretaId
            removerNaOrigem = payload.removerNaOrigem
        }
        await api.compradorComprasDiretas.excluir(compraDiretaId, removerNaOrigem)
    },

    async [actionTypes.REMOVER_DOCUMENTO_SOLICTADO]({ commit }, { compraDiretaId, documentoSolicitadoId }) {
        await api.documentosSolicitados.excluir(compraDiretaId, documentoSolicitadoId)
        commit(mutationTypes.SET_REMOVER_DOCUMENTO_SOLICITADO, documentoSolicitadoId)
    },

    async [actionTypes.REMOVER_EMAIL_CONVIDADO]({ commit }, { compraDiretaId, convidadoId }) {
        await api.convidados.excluir(compraDiretaId, convidadoId)
        commit(mutationTypes.SET_REMOVER_EMAIL_CONVIDADO, convidadoId)
    },

    async [actionTypes.REMOVER_ITEM]({ commit }, { compraDiretaId, itemId }) {
        await api.compradorComprasDiretas.excluirItem(compraDiretaId, itemId)
        commit(mutationTypes.SET_REMOVER_ITEM, itemId)
    },

    async [actionTypes.REMOVER_LOTE]({ commit }, { compraDiretaId, loteId }) {
        await api.compradorComprasDiretas.excluirLote(compraDiretaId, loteId)
        commit(mutationTypes.SET_REMOVER_LOTE, loteId)
    },

    async [actionTypes.REMOVER_LINHA_FORNECIMENTO]({ commit }, { compraDiretaId, linhaFornecimentoCompraDiretaId }) {
        await api.linhasFornecimento.excluir(compraDiretaId, linhaFornecimentoCompraDiretaId)
        commit(mutationTypes.SET_REMOVER_LINHA_FORNECIMENTO, linhaFornecimentoCompraDiretaId)
    },

    async [actionTypes.SALVAR_DADOS_GERAIS](context, dadosGerais) {
        return await api.compradorComprasDiretas.salvarDadosGerais(dadosGerais)
    },

    async [actionTypes.COMPRADOR.SALVAR_DADOS_GERAIS_NOVA_COMPRA]({ dispatch }, dadosGerais) {
        await api.compradorComprasDiretas.salvarDadosGeraisNovaCompra(dadosGerais)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, dadosGerais.id)
    },

    async [actionTypes.PUBLICAR_COMPRA_DIRETA]({commit}, compraDiretaId) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        await api.compradorComprasDiretas.publicar(compraDiretaId)
    },

    async [actionTypes.SALVAR_ITENS_E_LOTES](context, { itensELotes, compraDiretaId }) {
        return await api.compradorComprasDiretas.salvarItensELotes(itensELotes, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.BUSCAR_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA]({ commit }, numeroProcesso) {
        const { data } = await api.compradorComprasDiretas.buscarAutocompleteImportarCompraDireta(numeroProcesso)
        commit(mutationTypes.COMPRADOR.SET_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA, data.processos)
    },

    async [actionTypes.FORNECEDOR.VALIDAR_PARA_PROPOSTA](context, compraDiretaId) {
        return await api.fornecedorComprasDiretas.validarParaProposta(compraDiretaId)
    },

    async [actionTypes.COMPRADOR.VALIDAR_PARA_PROPOSTA](context, { compraDiretaId, fornecedorId }) {
        return await api.compradorComprasDiretas.validarParaProposta(compraDiretaId, fornecedorId)
    },

    [actionTypes.FORMATAR_LISTA_DE_ITENS_E_LOTES](context, objeto) {
        let resultado = {
            itens: [],
            itensDisponiveis: [],
            itensIndisponiveis: [],
            lotes: [],
            lotesDisponiveis: [],
            lotesIndisponiveis: []
        }
        resultado.itens = objeto.itens
        resultado.lotes = objeto.lotes
        objeto.itens.forEach(item => {
            if (item.situacao === 'EM_ANDAMENTO') {
                item.selecionado = false
                resultado.itensDisponiveis.push(item)
            } else {
                item.selecionado = true
                resultado.itensIndisponiveis.push(item)
            }
        })
        objeto.lotes.forEach(lote => {
            if (lote.situacao === 'EM_ANDAMENTO') {
                lote.selecionado = false
                resultado.lotesDisponiveis.push(lote)
            } else {
                lote.selecionado = true
                resultado.lotesIndisponiveis.push(lote)
            }
        })
        resultado.itensDisponiveis.sort((a, b) => {
            return a.sequencia - b.sequencia
        })
        resultado.itensIndisponiveis.sort((a, b) => {
            return a.sequencia - b.sequencia
        })
        resultado.lotesDisponiveis.sort((a, b) => {
            return a.descricao.localeCompare(b.descricao)
        })
        resultado.lotesIndisponiveis.sort((a, b) => {
            return a.descricao.localeCompare(b.descricao)
        })
        return resultado
    },

    async [actionTypes.COMPRADOR.JUNTAR_DOCUMENTO_COMPRA_DIRETA](context, { compraDiretaId, documentoId, documentoVirtualizadoId, tipoDocumento, pessoaId }) {
        const { data } = await api.compradorComprasDiretas.juntarDocumentoCompraDireta(compraDiretaId, documentoId, documentoVirtualizadoId, tipoDocumento, pessoaId)
        return data
    },
    //TODO painel documentos compra direta
    async [actionTypes.COMPRADOR.BAIXAR_DOCUMENTO_COMPRA_DIRETA](context, { idVirtualizado, opcaoDownloadVirtualizacao, compraDiretaId, nomeArquivo, noProcessoDigital, uri }) {
        const response = await api.compradorComprasDiretas.baixarDocumentoCompraDireta(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital, uri)
        const { nome, contentType } = ArquivoDownloadUtils.resolveDownloadInfo(response, nomeArquivo, mimeTypes.pdf)
        downloadUtils.baixarBlob(response.data, nome, contentType)
    },
    //TODO acompanhamento capa compra direta
    async [actionTypes.COMPRADOR.BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA](context, { idVirtualizado, opcaoDownloadVirtualizacao, compraDiretaId, uri, noProcessoDigital }) {
        const nomeArquivo = 'Capa_compra_direta.pdf'
        const { data } = await api.compradorComprasDiretas.baixarDocumentoVirtualizado(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo,
            compraDiretaId, uri, noProcessoDigital)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },
    //TODO acompanhamento fornecedor notificado
    async [actionTypes.COMPRADOR.BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS](context, { idVirtualizado, opcaoDownloadVirtualizacao, compraDiretaId, uri, noProcessoDigital }) {
        const nomeArquivo = 'Fornecedores_notificados.pdf'
        const { data } = await api.compradorComprasDiretas.baixarDocumentoVirtualizado(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo,
            compraDiretaId, uri, noProcessoDigital)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },
    async [actionTypes.COMPRADOR.BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA_END_POINT](context, { compraDiretaId }) {
        const nomeArquivo = 'Capa_compra_direta.pdf'
        const { data } = await api.compradorComprasDiretas.baixarDocumentoEndPoint(nomeArquivo, compraDiretaId)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS_END_POINT](context, { compraDiretaId }) {
        const nomeArquivo = 'Fornecedores_notificados.pdf'
        const { data } = await api.compradorComprasDiretas.baixarDocumentoEndPoint(nomeArquivo, compraDiretaId)
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.VIRTUALIZAR_DOCUMENTO_COMPRA_DIRETA](context, { compraDiretaId, tipoDocumento }) {
        const { data } = await api.compradorComprasDiretas.virtualizarDocumentoCompraDireta(compraDiretaId, tipoDocumento)
        return data
    },

    async [actionTypes.EXIBIR_NO_PNCP]({ state }, { cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp }) {
        if(urlFrontendPncp) {
            window.open(urlFrontendPncp, '_blank')
            return
        }

        let baseUrlPncp = state.parametros.propriedadesCompraDiretas.integration.pncp.uri
        if(baseUrlPncp.includes('api/')){
            baseUrlPncp = baseUrlPncp.substring(0, baseUrlPncp.indexOf('api/'))
        }

        const urlMontada = `${baseUrlPncp}editais/${cnpjOrgaoSuperiorPncp}/${ano}/${sequencialCompraPublica}`
        window.open(urlMontada, '_blank')
    },

    async [actionTypes.FORNECEDOR.ATUALIZAR_LOTE_PROPOSTA_MAIOR_DESCONTO](context, data){
        await api.fornecedorComprasDiretas.atualizarLotePropostaMaiorDesconto(data.loteId, data)
        await context.dispatch(actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_DA_PROPOSTA, data.compraDiretaId)
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_LOTE_PROPOSTA_MAIOR_DESCONTO](context, data){
        await api.compradorComprasDiretas.atualizarLotePropostaMaiorDesconto(data.loteId, data)
        await context.dispatch(actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_DA_PROPOSTA, data.compraDiretaId)
    },

    async [actionTypes.COMPRADOR.BAIXAR_TODOS_DOCUMENTOS_APRESENTADOS](context, input){
        const {data} = await api.compradorComprasDiretas.baixarTodosDocumentosApresentados({compraDiretaId: input.compraDiretaId, pessoaId: input.pessoaId})
        downloadUtils.baixarBlob(data, `DOCs_${input.razaoSocial.replaceAll(' ', '_')}.zip`, mimeTypes.zip)
    },

    async [actionTypes.UPLOAD_ARQUIVO_SEM_LOKI](context, arquivo){
        const {data} = await api.arquivoApi.upload(arquivo)

        return {arquivo: data}
    },

    async [actionTypes.DOWNLOAD_ANEXO](context, arquivoInfo){
        const response = await api.arquivoApi.download(arquivoInfo.uri)
        const contentType = response && response.headers ? (response.headers['content-type'] || mimeTypes.pdf) : mimeTypes.pdf
        const nomeArquivo = ArquivoDownloadUtils.resolveDownloadFilename(response, arquivoInfo.nome)
        downloadUtils.baixarBlob(response.data, nomeArquivo, contentType)
    },

    async [actionTypes.FORNECEDOR.BAIXAR_TERMO_ACEITE_PROPOSTA](context, propostId){
        const response = await api.fornecedorComprasDiretas.baixarTermoAceiteProposta(propostId)
        downloadUtils.baixarBlob(response.data, `termoaceite_proposta${propostId}_${Date.now()}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BAIXAR_RELATORIO_TERMO_VIRTUALIZADO](context, dados){
        const response = await api.fornecedorComprasDiretas.baixarRelatorioTermoVirtualizado(dados)
        downloadUtils.baixarBlob(response.data, `termoaceite_proposta_virtualizado_${Date.now()}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE](context, {compraDiretaId, id, tipo}){
        const {data} = await api.compradorComprasDiretas.baixarRelatorioPropostasItemLote(compraDiretaId, id, tipo)
        downloadUtils.baixarBlob(data, `propostas_CD${compraDiretaId}_${tipo}${id}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.ENVIAR_SOLICITACAO_REAJUSTE_ITEM_LOTE](context, dados){
        await api.compradorComprasDiretas.enviarSolicitacaoReajusteItemLote(dados)
    },

    async [actionTypes.FORNECEDOR.ATUALIZAR_READEQUACAO_ITEM_LOTE](context, dados){
        await api.fornecedorComprasDiretas.atualizarReadequacaoItemLote(dados)
    },
    async [actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO](context, {idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital}){
        const {data} = await api.arquivoApi.baixarDocumentoVirtualizado(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital)
        downloadUtils.baixarBlob(data, `${nomeArquivo}-${compraDiretaId}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.COMPRADOR.CANCELAR_NEGOCIACAO](context, {compraDiretaId, itemOuLoteId, tipoItemOuLote, negociacaoId, motivo}){
        await api.compradorComprasDiretas.cancelarNegociacao(compraDiretaId, itemOuLoteId, tipoItemOuLote, negociacaoId, motivo)
        await context.dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, compraDiretaId)
    },

    async [actionTypes.COMPRADOR.BUSCAR_NOTIFICACOES_COMPRADOR]({commit, state}){
        const paginacao = state.notificacoes.paginacao
        const situacoes = state.notificacoes.filtros.situacoes
        const tipos = state.notificacoes.comprador.tipos

        const input = {
            usuarioId: state.loki.user.id,
            situacoes: situacoes,
            ...paginacao,
            tipos: tipos
        }
        const { data } = await api.compradorComprasDiretas.buscarNotificacoesComprador(input)
        commit(mutationTypes.LOKI.SET_NOTIFICACOES, data)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_NOTIFICACOES_FORNECEDOR]({commit, state}){
        const paginacao = state.notificacoes.paginacao
        const situacoes = state.notificacoes.filtros.situacoes
        const tipos = state.notificacoes.fornecedor.tipos

        const input = {
            pessoaId: state.loki.user.domainId,
            situacoes: situacoes,
            ...paginacao,
            tipos: tipos
        }
        const { data } = await api.fornecedorComprasDiretas.buscarNotificacoesFornecedor(input)
        commit(mutationTypes.LOKI.SET_NOTIFICACOES, data)
    },

    async [actionTypes.COMPRADOR.CONTAR_NOTIFICACOES_NAO_LIDAS_COMPRADOR]({commit, state}){
        const input = {
            usuarioId: state.loki.user.id,
            tipos: state.notificacoes.comprador.tipos
        }
        const { data } = await api.compradorComprasDiretas.contarNotificacoesNaoLidas(input)
        commit(mutationTypes.LOKI.SET_NOTIFICACOES_NAO_LIDAS, data.totalNaoLidas)
    },

    async [actionTypes.FORNECEDOR.CONTAR_NOTIFICACOES_NAO_LIDAS_FORNECEDOR]({commit, state}){
        const input = {
            pessoaId: state.loki.user.domainId,
            tipos: state.notificacoes.fornecedor.tipos
        }
        const { data } = await api.fornecedorComprasDiretas.contarNotificacoesNaoLidas(input)
        commit(mutationTypes.LOKI.SET_NOTIFICACOES_NAO_LIDAS, data.totalNaoLidas)
    },

    async [actionTypes.MARCAR_NOTIFICACAO_LIDA]({ dispatch }, notificacaoId){
        await api.compraDireta.marcarNotificacaoLida(notificacaoId)
        dispatch(actionTypes.BUSCAR_UMA_UNICA_NOTIFICACAO, notificacaoId)
    },

    async [actionTypes.COMPRADOR.BUSCAR_DESTINATARIO_CHAT_E_MENSAGENS]({ commit, state }){
        const snapshot = {
            compraDiretaId: state.chat.conversacao.compra.compraDiretaId,
            pessoaId: state.chat.conversacao.destinatario.id,
            itemId: state.chat.conversacao.compra.itemCompraDiretaId,
            loteId: state.chat.conversacao.compra.loteCompraDiretaId,
        }
        const dados = {
            pessoaId: snapshot.pessoaId,
            itemId: snapshot.itemId,
            loteId: snapshot.loteId,
            ...state.chat.conversacao.paginacao
        }
        const { data } = await api.compradorComprasDiretas.buscarConversacaoChatMensagens(snapshot.compraDiretaId, dados)
        const atual = {
            compraDiretaId: state.chat.conversacao.compra.compraDiretaId,
            pessoaId: state.chat.conversacao.destinatario.id,
            itemId: state.chat.conversacao.compra.itemCompraDiretaId,
            loteId: state.chat.conversacao.compra.loteCompraDiretaId,
        }
        const mesmoContexto = Number(snapshot.compraDiretaId) === Number(atual.compraDiretaId)
            && Number(snapshot.pessoaId) === Number(atual.pessoaId)
            && Number(snapshot.itemId || 0) === Number(atual.itemId || 0)
            && Number(snapshot.loteId || 0) === Number(atual.loteId || 0)
        if (!mesmoContexto) return
        commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, data.mensagens)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_CONVERSACAO_CHAT_MENSAGENS]({ commit, state }){
        const compraDiretaId = state.chat.conversacao.compra.compraDiretaId
        const dados = {
            itemCompraDiretaId: state.chat.conversacao.compra.itemCompraDiretaId,
            loteCompraDiretaId: state.chat.conversacao.compra.loteCompraDiretaId,
            ...state.chat.conversacao.paginacao
        }
        const { data } = await api.fornecedorComprasDiretas.buscarConversacaoChatMesnagens(compraDiretaId, dados)
        commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, data.mensagens)
        //commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, data.destinatario)
    },

    async [actionTypes.COMPRADOR.BUSCAR_NOTIFICACOES_CHAT_COMPRADOR]({commit, state}){
        const input = {
            situacoes: state.chat.filtros.situacoes,
            ...state.chat.paginacao
        }

        const { data } = await api.compradorComprasDiretas.buscarNotificacoesChatComprador(input)
        commit(mutationTypes.SET_CHAT_NOTIFICACOES, data)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_NOTIFICACOES_CHAT_FORNECEDOR]({commit, state}){
        const input = {
            situacoes: state.chat.filtros.situacoes,
            ...state.chat.paginacao
        }

        const { data } = await api.fornecedorComprasDiretas.buscarNotificacoesChatFornecedor(input)
        commit(mutationTypes.SET_CHAT_NOTIFICACOES, data)
    },

    async [actionTypes.MARCAR_NOTIFICACAO_MENSAGEM_LIDA]({ dispatch }, notificacaoId){
        await api.compraDireta.marcarNotificacaoLida(notificacaoId)
        dispatch(actionTypes.BUSCAR_UMA_UNICA_NOTIFICACAO_CHAT, notificacaoId)
    },

    async [actionTypes.BUSCAR_UMA_UNICA_NOTIFICACAO]({state, dispatch, commit}, notificacaoId){
        const { data } = await api.compradorComprasDiretas.buscarUmaUnicaNotifificao(notificacaoId)
        commit(mutationTypes.SET_NOTIFICAO_PARA_LIDA, data)

        if(state.loki.user.domainType === 'FORNECEDOR') {
            dispatch(actionTypes.FORNECEDOR.CONTAR_NOTIFICACOES_NAO_LIDAS_FORNECEDOR)
        }else {
            dispatch(actionTypes.COMPRADOR.CONTAR_NOTIFICACOES_NAO_LIDAS_COMPRADOR)
        }
    },

    async [actionTypes.BUSCAR_UMA_UNICA_NOTIFICACAO_CHAT]({commit}, notificacaoId){
        const { data } = await api.compradorComprasDiretas.buscarUmaUnicaNotifificao(notificacaoId)
        commit(mutationTypes.SET_NOTIFICAO_CHAT_PARA_LIDA, data)
    },

    async [actionTypes.COMPRADOR.CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_COMPRADOR]({commit, state}){
        const input = {
            usuarioId: state.loki.user.id,
            tipos: state.notificacoes.comprador.tipoMensagem
        }
        const { data } = await api.compradorComprasDiretas.contarNotificacoesNaoLidas(input)
        commit(mutationTypes.SET_CHAT_NOTIFICACOES_NAO_LIDAS, data.totalNaoLidas)
    },

    async [actionTypes.FORNECEDOR.CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_FORNECEDOR]({commit, state}){
        const input = {
            pessoaId: state.loki.user.domainId,
            tipos: state.notificacoes.fornecedor.tipoMensagem
        }
        const { data } = await api.fornecedorComprasDiretas.contarNotificacoesNaoLidas(input)
        commit(mutationTypes.SET_CHAT_NOTIFICACOES_NAO_LIDAS, data.totalNaoLidas)
    },

    async [actionTypes.CONTAR_MENSAGENS_PARA_CENTRAL_CHAT]({commit, state}, {compraDiretaId, ehComprador}){
        const origemMensagem = ehComprador ? state.chat.conversacao.origem.fornecedor : state.chat.conversacao.origem.comprador
        const { data } = await api.compraDireta.contarMensagensCentralChat(compraDiretaId, origemMensagem)
        commit(mutationTypes.SET_TOTAL_MENSAGENS_NAO_LIDAS_CENTRAL, data.totalNaoLidas)
    },

    async [actionTypes.CONTAR_MENSAGENS_NAO_LIDAS_ITENS_LOTES]({ state }, {compraDiretaId, ehComprador}){
        const origemMensagem = ehComprador ? state.chat.conversacao.origem.fornecedor : state.chat.conversacao.origem.comprador

        return await api.compraDireta.contarMensagensNaoLidasItensLotes(compraDiretaId, origemMensagem)
    },

    async [actionTypes.MARCAR_MENSAGENS_LIDAS_ITENS_LOTES]({ state }, {tipo, ehComprador}){
        const origemMensagem = ehComprador ? state.chat.conversacao.origem.fornecedor : state.chat.conversacao.origem.comprador
        const itemOuLoteId = 'ITEM' === tipo ? state.chat.conversacao.compra.itemCompraDiretaId : state.chat.conversacao.compra.loteCompraDiretaId

        const data = {
            itemOuLoteId: itemOuLoteId,
            compraDiretaId: state.chat.conversacao.compra.compraDiretaId,
            tipo: tipo,
            origemMensagem: origemMensagem

        }
        return await api.compraDireta.marcarMensagensLidasItensLotes(data)
    },

    async [actionTypes.COMPRADOR.BAIXAR_DOCUMENTOS_EM_LOTE](context, dadosDocumentos){
        const {data} = await api.compradorComprasDiretas.baixarDocumentoVirtualizadoZipado(dadosDocumentos)
        downloadUtils.baixarBlob(data, `documentos_compra_direta_${dadosDocumentos[0].compraDiretaId}.zip`, mimeTypes.zip)
    },

    async [actionTypes.COMPRADOR.JUNTAR_DOCUMENTOS_EM_LOTE](context, dadosDocumentos){
        const {data} = await api.compradorComprasDiretas.juntarDocumentosEmLote(dadosDocumentos)
        return data
    },

    async [actionTypes.COMPRADOR.INICIAR_ASSINATURA_DOCUMENTOS_EM_LOTE](context, {compraDiretaId, usuarioId, documentos}){
        const {data} = await api.compradorComprasDiretas.iniciarAssinaturaDocumentosEmLote(compraDiretaId, usuarioId, documentos)
        return data
    },

    async [actionTypes.COMPRADOR.FINALIZAR_ASSINATURA_DOCUMENTOS_EM_LOTE](context, dadosAssinatura){
        const {data} = await api.compradorComprasDiretas.finalizarAssinaturaDocumentosEmLote(dadosAssinatura)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_ULTIMO_REAJUSTE_POR_MODALIDADE](){
        const { data } = await api.CompradorIndicePrecoApiClient.buscarUltimoReajustePorModalidade()
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_MODALIDADE_INDICE_PRECO](){
        const { data } = await api.CompradorIndicePrecoApiClient.buscarModalidades()
        return data
    },

    async [actionTypes.COMPRADOR.ADICIONAR_MODALIDADE_INDICE_PRECO](context, payload) {
        const { data } = await api.CompradorIndicePrecoApiClient.adicionarModalidadeIndicePreco(payload)
        return data
    },

    async [actionTypes.COMPRADOR.REMOVER_REAJUSTE_INDICE_PRECO](context, {modalidadeId, reajusteId}) {
        await api.CompradorIndicePrecoApiClient.removerReajusteIndicePreco(modalidadeId, reajusteId)
    },

    async [actionTypes.COMPRADOR.CRIAR_REAJUSTE_INDICE_PRECO](context, dados) {
        const { data } = await api.CompradorIndicePrecoApiClient.criarReajusteIndicePreco(dados)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_HISTORICO_REAJUSTE_POR_MODALIDADE](context, modalidadeId){
        const { data } = await api.CompradorIndicePrecoApiClient.buscarHistoricoReajuste(modalidadeId)
        return data
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_PERCENTUAL_REAJUSTE](context, dados){
        await api.CompradorIndicePrecoApiClient.atualizarPercentualReajuste(dados)
    },

    async [actionTypes.COMPRADOR.SALVAR_REAJUSTE_INDICE_PRECO_EM_MASSA](context, dados){
        await api.CompradorIndicePrecoApiClient.salvarReajusteIndicePrecoEmMassa(dados)
    },

    async [actionTypes.COMPRADOR.BUSCAR_CONFIGURACAO_PRAZO_INCISOS](){
        const { data } = await api.compradorComprasDiretas.buscarConfiguracaoPrazoIncisos()
        return data
    },

    async [actionTypes.COMPRADOR.REMOVER_CONFIGURACAO_PRAZO_INCISO](context, dados){
        await api.compradorComprasDiretas.removerConfiguracaoPrazoInciso(dados)
    },

    async [actionTypes.COMPRADOR.BUSCAR_AMPAROS_LEGAIS_HIERARQUICO](context, filtros){
        const { data } = await api.compradorComprasDiretas.buscarAmparosLegaisHierarquico(filtros)
        return data
    },

    async [actionTypes.COMPRADOR.CADASTRAR_CONFIGURACAO_PRAZO_INCISO](context, dados){
        const { data } = await api.compradorComprasDiretas.cadastrarConfiguracaoPrazoInciso(dados)
        return data
    },

    async [actionTypes.COMPRADOR.ATUALIZAR_CONFIGURACAO_PRAZO_INCISO](context, dados){
        const { data } = await api.compradorComprasDiretas.atualizarConfiguracaoPrazoInciso(dados)
        return data
    },

    async [actionTypes.AUTORIDADE_SUPERIOR.BUSCAR_COMPRAS_DIRETAS_HOMOLOGACAO](){
        const {data} = await api.compradorComprasDiretas.buscarComprasDiretasHomologacao()
        return data
    },
    async [actionTypes.AUTORIDADE_SUPERIOR.DEVOLVER_ITEM_LOTE]({dispatch}, dados){
        await api.compradorComprasDiretas.devolverItemLote(dados)
        await dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, dados.compraDiretaId)
        await dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, dados.compraDiretaId)
    },

    async [actionTypes.COMPRADOR.BAIXAR_TERMO_HOMOLOGACAO](context, compraDiretaId) {
        const { data } = await api.compradorComprasDiretas.baixarTermoHomologacao(compraDiretaId)
        downloadUtils.baixarBlob(data, `termohomologacao_${compraDiretaId}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.FORNECEDOR.BUSCAR_ITEM_LOTE_LANCES_DESEMPATE](context, compraDiretaId){
        const {data} = await api.fornecedorComprasDiretas.buscarItemLoteLancesDesempate(compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_LISTAGEM_PAGINADA](context, payload) {
        const defaults = { page: 1, rowsPerPage: 10, sort: 'ASC', sortBy: 'id' }
        const { conteudo, paginacao } = typeof payload === 'string'
            ? { conteudo: payload, paginacao: defaults }
            : payload
        const filtro = { conteudo }
        const pag = { ...defaults, ...(paginacao || {}) }
        const { data } = await api.compradorComprasDiretas.buscarListagemPaginada(filtro, pag)
        return data
    },

    async [actionTypes.COMPRADOR.REMOVER_REQUISICAO_COM_ERRO](context, { id, ...data }) {
        await api.compradorComprasDiretas.removerRequisicaoComErro(id, data)
    },

    async [actionTypes.COMPRADOR.DESENTRANHAR_DOCUMENTO_VIRTUALIZADO](context, requestData) {
        const { data } = await api.compradorComprasDiretas.desentranharDocumentoVirtualizado(requestData)
        return data
    },

    async [actionTypes.COMPRADOR.DESENTRANHAR_DOCUMENTO_VIRTUALIZADOV2](context, inputData) {
        const { data } = await api.compradorComprasDiretas.desentranharDocumentoVirtualizadoV2(inputData)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_DOCUMENTO_EDITOR_TEXTO_POR_ID](context, idDocumento){
        const { data } = await api.compradorComprasDiretas.buscarDocumentoEditorTextoPorId(idDocumento)
        return data
    },

    async [actionTypes.COMPRADOR.SINCRONIZAR_DOCUMENTO_EDITOR_TEXTO](context, { idDocumentoEditorTexto }){
        const { data } = await api.compradorComprasDiretas.sincronizarDocumentoEditorTexto(idDocumentoEditorTexto)
        return data
    },

    async [actionTypes.COMPRADOR.BUSCAR_INFOS_DOC_DESENTRANHAMENTO]({ commit }, requestData) {
        const { data } = await api.compradorComprasDiretas.buscarInfosDocDesentranhamento(requestData)
        commit(mutationTypes.COMPRADOR.SET_DOCUMENTO_DESENTRANHAMENTO, data)
    },

    async [actionTypes.COMPRADOR.REORDENAR_DOCUMENTO_VIRTUALIZADO](context, requestData) {
        const { data } = await api.compradorComprasDiretas.reordenarDocumentoVirtualizado(requestData)
        return data
    },

    async [actionTypes.COMPRADOR.CANCELAMENTO_DOCUMENTO_VIRTUALIZADO](context, dados){
        await api.compradorComprasDiretas.cancelarDocumentoVirtualizado(dados)
    },

    async [actionTypes.COMPRADOR.BUSCAR_SITUACAO_DOCUMENTOS_EDOCS] (context, compraDiretaId) {
        await api.compradorComprasDiretas.buscarSituacaoEdocsDocumentos({ compraDiretaId })
    },

    async [actionTypes.COMPRADOR.ACESSAR_EDOCS] (context, processoId) {
        const { data } = await api.compradorComprasDiretas.acessarEdocs({ processoId })
        return data
    },

    async [actionTypes.COMPRADOR.RANKEAR_PROPOSTAS](context, { compraDiretaId }) {
        const { data } = await api.compradorComprasDiretas.rankearPropostas(compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.INSERIR_REAJUSTE_PROPOSTAS](context, { compraDiretaId }) {
        const { data } = await api.compradorComprasDiretas.inserirReajustePropostas(compraDiretaId)
        return data
    },

    async [actionTypes.COMPRADOR.ENVIAR_DOCUMENTOS_ANALISE]({ commit }, { compraDiretaId, fornecedorId }) {
        const { data } = await api.compradorComprasDiretas.enviarDocumentosAnalise(compraDiretaId, fornecedorId)
        commit(mutationTypes.FORNECEDOR.SET_ATUALIZAR_TODOS_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA, data)
    },

    /**
     * INTEGRAÇÃO ESFINGE
     */
    async [actionTypes.ESFINGE.ENVIAR_DISPENSA](context, compraDiretaId){
        const {data} = await api.compradorComprasDiretas.enviarDispensaEsfinge(compraDiretaId)
        return data
    },

    async [actionTypes.ESFINGE.ALTERAR_DISPENSA](context, compraDiretaId){
        const {data} = await api.compradorComprasDiretas.alterarDispensaEsfinge(compraDiretaId)
        return data
    },

    async [actionTypes.ESFINGE.BUSCAR_DISPENSA](context, compraDiretaId){
        const {data} = await api.compradorComprasDiretas.buscarDispensaEsfinge(compraDiretaId)
        return data
    },

    async [actionTypes.ESFINGE.CANCELAR_DISPENSA](context, compraDiretaId){
        const {data} = await api.compradorComprasDiretas.cancelarDispensaEsfinge(compraDiretaId)
        return data
    },

    async [actionTypes.ESFINGE.ENVIAR_OCORRENCIA](context, dados){
        const {data} = await api.compradorComprasDiretas.enviarOcorrenciaEsfinge(dados)
        return data
    },

    async [actionTypes.ESFINGE.ALTERAR_OCORRENCIA](context, dados){
        const {data} = await api.compradorComprasDiretas.alterarOcorrenciaEsfinge(dados)
        return data
    },

    async [actionTypes.ESFINGE.BUSCAR_OCORRENCIA](context, numeroProtocolo){
        const {data} = await api.compradorComprasDiretas.buscarOcorrenciaEsfinge(numeroProtocolo)
        return data
    },

    async [actionTypes.ESFINGE.BUSCAR_LISTAGEM_PAGINADA_PROTOCOLOS_OCORRENCIA](context, params){
        const {data} = await api.compradorComprasDiretas.buscarListagemPaginadaProtocolosOcorrencia(params)
        return data
    },

    async [actionTypes.ESFINGE.CANCELAR_OCORRENCIA](context, { compraDiretaId, numeroProtocolo, itemLoteCompraDiretaId, identificador }){
        const {data} = await api.compradorComprasDiretas.cancelarOcorrenciaEsfinge({ compraDiretaId, numeroProtocolo, itemLoteCompraDiretaId, identificador })
        return data
    },


    /**
     * INTEGRAÇÃO LEGADO
     */

    async [actionTypes.LEGADO.BUSCAR_LISTAGEM_PROCESSO]({ state }) {
        const filtro = state.comprador.resultadoBuscaComprasLegadas.filtros
        const paginacao = state.comprador.resultadoBuscaComprasLegadas.paginacao

        const dadosFiltros = {
            page: paginacao.page,
            rowsPerPage: paginacao.rowsPerPage,
            conteudo: filtro.conteudo
        }
        const { data } = await api.legado.buscarListagemProcesso(dadosFiltros)
        return data
    },

    async [actionTypes.LEGADO.BUSCAR_PROCESSO_POR_ID](context, processoAquisicaoId) {
        const { data } = await api.legado.buscarProcessoPorId(processoAquisicaoId)
        return data
    },

    async [actionTypes.LEGADO.BUSCAR_EXECUCOES_POR_PROCESSO](context, processoAquisicaoId) {
        const { data } = await api.legado.buscarExecucoesPorProcesso(processoAquisicaoId)
        return data
    },

    async [actionTypes.LEGADO.BUSCAR_ITENS_LOTES](context, { processoAquisicaoId, execucaoId }) {
        const { data } = await api.legado.buscarItensLotes(processoAquisicaoId, execucaoId)
        return data
    },

    async [actionTypes.LEGADO.BUSCAR_RESULTADO_EXECUCAO](context, { processoAquisicaoId, execucaoId }) {
        const {data} = await api.legado.buscarResultadoExecucao(processoAquisicaoId, execucaoId)
        return data
    },

    async [actionTypes.LEGADO.BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE_LEGADO](context, {processoAquisicaoId, execucaoId, id, tipo}){
        const {data} = await api.legado.baixarRelatorioPropostasItemLoteLegado(processoAquisicaoId, execucaoId, id, tipo)
        downloadUtils.baixarBlob(data, `propostas_${processoAquisicaoId}_${tipo}${id}.pdf`, mimeTypes.pdf)
    },
}
